import {POST_FAILED, REQUEST_NEW_SITE, SET_ONPREMISE_STATE} from "../types";
import Api from '../../services/Api'

export const addElement = (type, element) => dispatch => {
    dispatch({
        type: type,
        payload: element
    })
}

export const setOnPremiseState = (s) => dispatch => {
    dispatch({
        type: SET_ONPREMISE_STATE,
        payload: s,
    })
}

export const createSite = (element) => dispatch => {
    Api.post('/CreateSiteRequest', element)
    .then(res => res.data)
    .then(post => {
            if (post === 200) {
                dispatch({
                    type: REQUEST_NEW_SITE,
                    payload: "Order is created"
                })
            } else {
                console.log("Log error")
                dispatch({
                    type: POST_FAILED,
                    payload: "Failed to create order"
                })
            }
        }
    ).catch((error) => {
        console.log(error)
    })
}


// WEBPACK FOOTER //
// ./src/actions/CreateSiteActions/createSiteActions.js